
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/client/js",
      function () {
        return require("private-next-pages/docs/client/js.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/client/js"])
      });
    }
  